import { Clock, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { signOut } from "@/lib/auth-client";

export default function ClubSetupPending() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut({ fetchOptions: { onSuccess: () => navigate("/login") } });
  }

  return (
    <div className="min-h-svh flex items-center justify-center bg-neutral-50 px-4">
      <div className="flex flex-col items-center gap-4 py-8 text-center max-w-sm">
        <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center">
          <Clock className="w-7 h-7 text-primary-500" />
        </div>
        <div>
          <p className="font-semibold text-neutral-800">
            {t("clubSetupPending.heading")}
          </p>
          <p className="text-sm text-neutral-500 mt-1">
            {t("clubSetupPending.message")}
          </p>
        </div>
        <button
          onClick={handleLogout}
          className="inline-flex items-center gap-1.5 text-sm text-neutral-500 hover:text-neutral-800 cursor-pointer transition-colors"
        >
          <LogOut className="w-4 h-4" />
          {t("nav.logout")}
        </button>
      </div>
    </div>
  );
}
